import { Injectable } from '@angular/core';
import { createMask } from '@ngneat/input-mask';

@Injectable({
  providedIn: 'root',
})
export class MaskService {
  public priceInputMask = createMask({
    alias: 'numeric',
    placeholder: '',
    digits: 2,
    min: 0,
    groupSeparator: '',
    radixPoint: ',',
  });

  public geoLocationInputMask = createMask({
    alias: 'numeric',
    digits: 6,
    min: -180,
    groupSeparator: '',
    radixPoint: ',',
    rightAlign: false,
  });
}
